import React from 'react';

/**
 * Indicateur documents à signer (Prysme Access).
 * - `border` : contour fixe qui pulse en orange (cartes application)
 * - `ping`   : halo élargi (autres zones, en attente de refonte)
 */
export default function PendingDocumentsAppIndicator({
  active,
  roundedClass = 'rounded-[inherit]',
  variant = 'ping',
}) {
  if (!active) return null;

  if (variant === 'border') {
    return (
      <span
        className={`pointer-events-none absolute inset-0 z-[5] box-border ${roundedClass} pending-docs-app-card-border`}
        title="Documents à signer dans Prysme Access"
        aria-hidden
      />
    );
  }

  return (
    <span
      className={`pointer-events-none absolute inset-0 z-[5] ${roundedClass} animate-ping`}
      style={{ border: '2px solid rgb(251, 146, 60)', opacity: 0.65 }}
      title="Documents à signer dans Prysme Access"
      aria-hidden
    />
  );
}
